import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './changepin.scss'

// Utils
import { translation } from '../../../utils/helpers'

// actions'
import { changePincode } from '../../../actions/auth'

// Elements
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Button from '../../../shared/elements/button'
import Text from '../../../shared/elements/text'
import Label from '../../../shared/elements/label'

class ChangePin extends Component {
  constructor (props) {
    super(props)
    this.state = {
      NewPin: '',
      ConfirmPin: ''
    }
    this.onChange = this.onChange.bind(this)
    this.changePin = this.changePin.bind(this)
  }

  onChange ({ target: { name, value } }) {
    this.setState({
      [name]: value
    })
  }

  changePin () {
    let { NewPin, ConfirmPin } = this.state
    const regex = /^[0-9\b]+$/

    if (NewPin !== ConfirmPin) {
      window.toastr.error(translation('17966'), translation('216'))
      return
    }

    if (!regex.test(NewPin)) {
      window.toastr.error(translation('18035'), translation('216'))
      return
    }

    if (NewPin.length < 4 || NewPin.length > 4) {
      window.toastr.error(translation('18036'), translation('216'))
      return
    }

    const data = {
      UserId: this.props.auth.user.UserId,
      NewPin: NewPin
    }

    this.props.changePincode(data).then((res) => {
      // window.toastr.success(translation('18037'), translation('13424'))
    }, (err) => {
      window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
    })
  }

  render () {
    let { NewPin, ConfirmPin } = this.state
    let hasPin = this.props.auth.user.UserHasPincode
    let title = hasPin ? translation('17961') : translation('17977')
    return (
      <div className='pin__screen'>
        <Col>
          <Panel title={title}>
            <Label size='l'>{translation('18064')}</Label>
            <Text isPassword labelText={translation('17963')} name='NewPin' value={NewPin} onChange={this.onChange} />
            <Text isPassword labelText={translation('17964')} name='ConfirmPin' value={ConfirmPin} onChange={this.onChange} />
            <Button onClick={this.changePin} labelText={translation('17965')} />
          </Panel>
        </Col>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { changePincode })(ChangePin)



// WEBPACK FOOTER //
// ./src/app/pages/Auth/ChangePin/index.js